import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi } from 'ag-grid-community';
import { Subject, SubscriptionLike } from 'rxjs';
import { AuditlogServiceService } from 'src/app/services/um/auditlog-service.service';

@Component({
  selector: 'app-auditlog-revisions',
  templateUrl: './auditlog-revisions.component.html',
  styleUrls: ['./auditlog-revisions.component.scss']
})
export class AuditlogRevisionsComponent implements OnInit {
  @Input() public Content: any;

  subGetAuditLogRevisionList: SubscriptionLike;
  rowData: any = [];
  columnDefs: any;
  selectedRow: any;
  gridApi: GridApi;
  gridColumnApi: any
  gridOptions: any;
  rowSelection;
  public content: any
  RevisionNo: any = []
  ArrayOfRevision: any = []

  action: Subject<any> = new Subject();

  constructor(
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    public ApiService: AuditlogServiceService) { }

  ngOnDestroy(): void {
    if (this.subGetAuditLogRevisionList)
      this.subGetAuditLogRevisionList.unsubscribe();
  }

  ngOnInit(): void {

    var ArrayRevisionNum = this.Content.content.RevisionNo
    this.RevisionNo = ArrayRevisionNum.filter((c, index) => {
      return ArrayRevisionNum.indexOf(c) === index;
    });

    this.gridHeaderandActionSettings();
    if (this.Content.content.RelatedPKID != null) {
      var CategoryType = this.Content.content.Category
      this.subGetAuditLogRevisionList = this.ApiService.GetAuditLogRevisionList(this.Content.content.RelatedPKID, CategoryType).subscribe(data => {
        this.rowData = data;
      })
    }
  }

  gridHeaderandActionSettings() {
    this.gridOptions = {
      pagination: true,
      rowSelection: 'multiple',
      suppressRowClickSelection: true,
      onFirstDataRendered: (params) => {
        params.api.forEachNode((node) =>
          this.RevisionNo.forEach((r) => {
            if (node.data.RevisionNum == r) {
              node.setSelected(true)
            }
          }
          ));
      }
    }
    this.columnDefs = [
      { headerName: "VersionId", headerTooltip: "VersionId", field: 'VersionID', sortable: false, tooltipField: "VersionID", hide: true, suppressToolPanel: true },
      { headerName: "Revision", headerTooltip: "Revision", field: 'RevisionNum', sortable: false, tooltipField: "RevisionNum", headerCheckboxSelection: true, checkboxSelection: true },
      { headerName: "Changed Date and Time", headerTooltip: "Changed Date and Time", field: 'CreatedDate', sortable: false, tooltipField: "CreatedDate" },
      { headerName: "Username", headerTooltip: "Username", field: 'CreatedBy', sortable: false, tooltipField: "CreatedBy" }
    ];
    this.rowSelection = 'multiple';
  }


  onSetGridApi(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    setTimeout(() => {
      if (true) {
        params.api.forEachNode((node: any) => {
          if (this.RevisionNo) {
            this.RevisionNo.forEach(element => {
              if (node.data.RevisionNum === element) {
                node.setSelected(true);
              }
            });
          }
          else {

          }
        });
      }
    }, 500);
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }
  OnClickOk() {
    //debugger
    this.selectedRow = this.gridApi.getSelectedRows();
   // this.action.next(this.selectedRow);
    this.modalRef.close(this.selectedRow);
  }

  cancelmodal() {
    this.modalRef.dismiss();
  }

}
